<script>
import {ElNotification} from "element-plus";

export default {
  name: 'ImageUploader',
  props: {
    imageType: String,
    hashId: String
  },
  data() {
    return {
      loading: false,
      image: {
        type: null,
        name: 'Yuklang',
        fileUrl: null,
        file: null,
        hashId: null
      },
      tempFileUrl: null,
      baseUrl: process.env.VUE_APP_BASE_API_URL + '/api/v2/info/file/'
    }
  },
  methods: {
    handleChange(event) {
      this.tempFileUrl = URL.createObjectURL(event.target?.files[0]);
      this.image.file = event.target?.files[0];
      this.image.name = event.target?.files[0]?.name;
      this.image.type = this.imageType;
      this.uploadFile();
    },
    onClickFileAttach(fileLang) {
      this.$refs[fileLang].click()
    },
    uploadFile() {
      this.loading = true;
      let formData = new FormData();
      formData.append('file', this.image.file);

      this.$http.post('/api/v2/info/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(({data}) => {
            this.image.hashId = data.hashId;
            this.image.fileUrl = this.tempFileUrl;
            this.$emit('handleChange', this.image);
            ElNotification({
              message: "Rasim yuklandi!",
              type: "success",
            });
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Rasimni yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>

<template>
  <div class="file-wrapper" v-loading="loading"
       element-loading-background="rgba(122, 122, 122, 0.5)">
    <input
        size="large"
        @change="handleChange($event,imageType)"
        :ref="imageType"
        type="file"
        class="input-file"
        accept="image/jpeg,image/jpg,image/png"
        autocomplete="off"
        placeholder="Kiriting"
    />
    <div class="info">
      <el-avatar style="width: 80px;height: 60px" shape="square"
                 :src="!image.hashId&&hashId ? (baseUrl+hashId):image.fileUrl||require('@/assets/images/default-img.png')"/>
      <span class="file-name">{{ image.name }}</span>
    </div>
    <span class="attach-icon" @click="onClickFileAttach(imageType)">
                  <img alt="" class="upload-img" src="@/assets/images/icons/file-attatch.svg"/>
                </span>
  </div>
</template>

<style scoped>
.file-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #E6EAF9;
  border-radius: 5px;
  padding: 5px;

  .info {
    display: flex;
    align-items: center;
    gap: 10px
  }

  .input-file {
    display: none;
  }

  .attach-icon {
    cursor: pointer;
    margin-top: 10px;
  }

  .file-name {
    max-width: 200px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
